import { Component } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { TeacherSidenavbarComponent } from '@edtech-ui/dashboard/teacher/teacher-navbar/teacher-sidenavbar/teacher-sidenavbar.component';
import { SharedModule } from '@edtech-ui/shared/shared.module';

@Component({
  selector: 'app-admin-layout',
  standalone: true,
  imports: [SharedModule, RouterOutlet, RouterModule, TeacherSidenavbarComponent],
  templateUrl: './admin-layout.component.html',
  styleUrl: './admin-layout.component.scss'
})
export class AdminLayoutComponent {
  collapsed: boolean = false;

  toggleSidenav() {
    this.collapsed = !this.collapsed;
  }
}
